import {
  CAPABILITY_APM,
  CAPABILITY_BROWSER,
  CAPABILITY_MOBILE,
  CAPABILITY_VM,
  CAPABILITY_SM
} from '@/utils/constants';
import { GetterTree } from 'vuex';
import { State } from './alarm.store';

const getters: GetterTree<State, State> = {
  getCurrentAlarmService: (state, getters, rootState, rootGetters) => {
    let key = rootState['globalState']['app']['currentCapability'];
    let currService;
    switch (key) {
      case CAPABILITY_BROWSER:
        currService =
          rootState['browserState']['browserCommonState'][
            'currentBrowserService'
          ];
        break;
      case CAPABILITY_APM:
        currService = rootState['apmState']['apmCommonState']['currentService'];
        break;
      case CAPABILITY_MOBILE:
        currService =
          rootState['mobileState']['mobileCommonState']['currentMobileService'];
        break;
      case CAPABILITY_VM:
        currService = rootState['vmState']['vmCommonState']['currentVm'];
        break;
      case CAPABILITY_SM:
        currService =
          rootState['syntheticState']['commonState']['currentService'];
        break;
      default:
        break;
    }
    return currService;
  },
  getCurrentAlarmCapability: state => {
    return state.currentCapability;
  },
  getAlarmCapabilities: state => {
    return state.alarmCapabilities;
  },
  getAlarmApplications: state => {
    return state.alarmApplications;
  },
  getCurrentApplication: state => {
    return state.currentApplication;
  }
};
export default getters;
